module.exports = __webpack_public_path__ + "static/img/chzx-top1.5ffd15ab.png";